import Plyr from 'plyr'
import ee from '../ee'

const players = {}

function playHomepageVideo() {
  if ('homepageVideo' in players) {
    players['homepageVideo'].play()
  }
}

function pauseHomepageVideo() {
  if ('homepageVideo' in players) {
    players['homepageVideo'].pause()
  }
}

function init() {
  document.querySelectorAll('.js-video').forEach((el) => {
    const player = new Plyr(el, {
      showPosterOnEnd: true,
      fullscreen: false,
    })
    if (el.id) {
      players[el.id] = player
    }
  })
}

ee.addListener('initComponents', init)
ee.addListener('homepageVideoModalOpened', playHomepageVideo)
ee.addListener('homepageVideoModalClosed', pauseHomepageVideo)
